import React from 'react';
import PropTypes from 'prop-types';
import { StyledIconComments, StyledText } from './style';

const IconComments = props => (
  <StyledIconComments
    viewBox="0 0 24 24"
    className={props.className}
    color={props.color}
    id={props.id}
    size={props.size}
    onClick={props.onClick}
    width={props.width}
    height={props.height}
    hover={props.hover}
  >
    <g fillRule="evenodd">
      <path d="M2.25 15.908h19.49V3.402H2.25v12.506zM24 .667H0v17.977h3.541v4.69l7.307-4.69H24V.667z" />
      <StyledText x="12" y="13.5" textAnchor="middle">
        {props.numberComments > 0 && props.numberComments}
      </StyledText>
    </g>
  </StyledIconComments>
);

IconComments.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.string,
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'dark',
    'light',
    'error',
    'success'
  ]),
  size: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'xl']).isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  numberComments: PropTypes.number
};

IconComments.defaultProps = {
  color: 'dark'
};

export default IconComments;
